import { ITestimonialSection } from '@/interfaces/homepage';
import { TestimonialSlider } from './TestimonialSlider';

export function TestimonialSection({ content }: Readonly<{ content: ITestimonialSection }>) {
  if (!content.Items.length) return null;

  return (
    <section className="container" data-testid="testimonial-section">
      <div className="mb-8 flex-1 text-center lg:text-left">
        <div className="flex items-center justify-center gap-3 md:justify-start">
          <span className="h-8 w-8 rounded-full bg-red-500" />

          <h2 className="text-center text-2xl font-bold lg:text-4xl">{content.Title}</h2>
        </div>
      </div>
      <TestimonialSlider content={content} />
    </section>
  );
}
